import { isInteger } from "utils/validations";

export const handleOnDragEnd = (result, set_data, data) => {
  if (
    !isInteger(result?.destination?.index) ||
    !isInteger(result?.source?.index)
  )
    return;
  let temp = data;
  const reorderedData = temp.splice(result.source.index, 1);
  temp.splice(result.destination.index, 0, ...reorderedData);
  for (let i = 0; i < temp.length; i++) {
    let item = temp[i];
    item.id = i;
  }

  set_data([...temp]);
};
